// app/javascript/controllers/branch_filter_controller.js
import { Controller } from "@hotwired/stimulus"

// Controls filtering of branch sections on /categories/soldier_branches
// based on tags like: american, british, naval, militia, has-units, no-units
export default class extends Controller {
  static targets = ["branch", "button"]
  static values = {
    currentFilter: { type: String, default: "all" }
  }

  connect() {
    this.updateButtons()
    this.updateBranches()
  }

  // Called by clicking filter buttons
  apply(event) {
    event.preventDefault()

    const filter = event.currentTarget.dataset.branchFilterFilterParam || "all"
    this.currentFilterValue = filter

    this.updateButtons()
    this.updateBranches()
  }

  updateButtons() {
    const current = this.currentFilterValue

    this.buttonTargets.forEach((btn) => {
      const btnFilter = btn.dataset.branchFilterFilterParam || "all"
      if (btnFilter === current) {
        btn.classList.add("active")
      } else {
        btn.classList.remove("active")
      }
    })
  }

  updateBranches() {
    const current = this.currentFilterValue

    this.branchTargets.forEach((el) => {
      const tags = (el.dataset.tags || "").split(/\s+/).filter(Boolean)

      const matches =
        current === "all" ||
        tags.includes(current)

      if (matches) {
        el.classList.remove("d-none")
      } else {
        el.classList.add("d-none")
      }
    })
  }
}
